@if (
  scenariosFeature.selectors.scenarioMarkedForDeletion.asSignal();
  as scenario
) {
  <atn-ds-confirmation-overlay
    [title]="'Do you want to delete ' + scenario.name + '?'"
    [description]="
      'Deleting your scenario can\'t be undone. Are you sure you want to delete your scenario?'
    "
    (cancel)="cancelClickHandler()"
    (confirm)="confirmClickHandler()"
    [confirmButtonText]="'DELETE'"
  />
}
